<template>
  <div v-show="showToolsBox" :style="{ pointerEvents: isPointer?'none':'auto'}"
       class="officeReEdit"
       id="officeReEdit"
       ref="officeReEdit"
       @click="doPopoverClose()" v-loading="loading">
    <img v-if="drawBackgroundImage" :src="drawBackgroundImage"
         style="width: 100%;height: 100%;position: absolute;left: 0;top: 0"/>
    <popup-framework :start-el="startEl" :end-el="endEl"
                     :visible.sync="popupFrameworkShow"
                     :logo="currentEnv.css"
                     :title="currentEnv.systemType"
                     @popupResize="popupResize"
    >
      <it-env ref="itEnv" :platform-type="currentEnv.platformType" :iframe-src="iframeSrc"></it-env>
      <template v-slot:menu>
        <menu title="操作" style="cursor: pointer">
          <el-dropdown trigger="hover">
            <i class="el-icon-s-tools" style="padding: 8px"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-refresh-right" @click.native="resetOs()">重置数据</el-dropdown-item>
              <el-dropdown-item icon="el-icon-refresh" @click.native="restartOs()"
                                v-if="currentEnv.platformType !== envList.codeBlockOS.platformType">重启环境
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </menu>
      </template>
    </popup-framework>
    <div class='officeContent' id="officeContent">
      <div class="canvasBox" @click.stop="doPopoverClose()"
           :style="{ width:isEdit?canvasWidth+'px':'1px', height:canvasHeight+'px',pointerEvents: isPointer?'none':'auto'}">
        <canvas id='officeCanvas' ref="officeCanvas" :width="canvasWidth" :height="canvasHeight"></canvas>
      </div>
    </div>
    <div v-on:click.stop :style="{ pointerEvents: 'auto'}">
      <div class="officeTools" :style="{'--translateY':isEdit?'0%':'100%'}" v-if="!isGeneratePictures"
           @dblclick="maximizeTools($event.target)">
        <div class="drag dragLeft" v-drag="'left'">|||</div>
        <div class="drag dragRight" v-drag="'right'">|||</div>
        <div class="fold" @click="switchTools">
          <el-tooltip :content="`${(isEdit?'收起':'展开')}(F2)`" placement="top" effect="light">
            <i class='el-icon-minus' style="font-size:25px;width: 100%;height: 100%;text-align: center"></i>
          </el-tooltip>
        </div>
        <div class="leftTools">
          <div v-for="item in leftTools" :key="item.name" @click="handleLeftTools(item)" v-show="!item.isHide">
            <el-tooltip :content="item.label" placement="top" effect="light">
              <i :class="item.type"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="centerTools">
          <div v-for="(item,index) in centerTools.slice(0,2)" :key="item.name" v-show="!item.isHide">
            <el-tooltip slot="reference" :content="item.label" placement="top" effect="light">
              <i :class="item.type" :style=" {color:getDisableIsNext(index) ? '#ccc' : null ,cursor: 'pointer'}"
                 @click="handleCenterTools(item,index)"></i>
            </el-tooltip>
          </div>
          <div v-for="(item,index) in centerTools.slice(2,3)" :key="item.name" v-show="!item.isHide">
            <el-tooltip slot="reference" :content="item.label" placement="top" effect="light">
              <i :class="item.type" @click="handleCenterTools(item,index)" :style="getToolsStyle(item)"></i>
            </el-tooltip>
          </div>
          <div v-for="(item,index) in centerTools.slice(3)" :key="item.name" v-show="!item.isHide">
            <el-popover
              placement="top"
              width="auto"
              trigger="click"
              ref="mPopover"
              :openDelay="200"
            >
              <div v-if="item.name === 'pencil'"
                   style="display:grid;grid-template-columns: repeat(2,auto);justify-items: center;cursor: pointer">
                <div>
                  <el-color-picker :predefine="predefineColors" v-model="currentColor"
                                   @active-change="(color)=>pickerChange(color,'currentColor')"
                                   @change="(color)=>pickersChange(predefineColors,currentColor,color)"></el-color-picker>
                </div>
                <div>
                  <el-slider :min="1" :max="100" v-model="currentWidth" @change="sliderChange"
                             style="margin-left: 15px;width: 100px"></el-slider>
                </div>
              </div>
              <div v-else-if="item.name === 'eraser'"
                   style="display:grid;grid-template-columns: repeat(2,auto);justify-items: center;align-items: center;cursor: pointer">
                <div v-for="it in item.children" :key="it.name" @click="handleCenterTools(it)" v-show="!it.isHide">
                  <el-tooltip :content="it.label" placement="top" effect="light">
                    <i :class="it.type" style="font-size:24px;" @click="handleCenterTools(item)"></i>
                  </el-tooltip>
                </div>
                <div>
                  <el-slider :min="1" :max="100" v-model="currentEraserWidth" @change="sliderChange"
                             style="margin-left: 15px;width: 100px"></el-slider>
                </div>
              </div>
              <div v-else-if="item.name === 'more'"
                   style="display:grid;row-gap: 10px; grid-template-columns: repeat(3,auto);justify-items: center;cursor: pointer">
                <div v-for="(it,index) in item.children" :key="it.name" @click="handleCenterTools(it)"
                     style="width: 60px;text-align: center" v-show="!it.isHide">
                  <el-tooltip :content="it.label" :placement="index<3?'top':'bottom'" effect="light">
                    <i :class="it.type" style="font-size:24px;padding: 5px;margin: 2px" :style="getToolsStyle(it)"></i>
                  </el-tooltip>
                </div>
                <div
                  style="width: inherit;display: flex;grid-column: 1/5;border-radius: 5px;border: 1px solid #cccccc;padding: 4px;box-sizing: border-box">
                  <div>
                    <el-color-picker :predefine="predefineShapeColors" v-model="currentShapeColor"
                                     @active-change="(color)=>pickerChange(color,'currentShapeColor')"
                                     @change="(color)=>pickersChange(predefineShapeColors,currentShapeColor,color)"></el-color-picker>
                  </div>
                  <div>
                    <el-slider :min="1" :max="50" v-model="currentShapeWidth" @change="sliderChange"
                               style="margin-left: 15px;width: 110px;margin-right: 15px"></el-slider>
                  </div>
                </div>
              </div>
              <el-tooltip slot="reference" :content="item.label" placement="top" effect="light">
                <i :class="item.type" @click="handleCenterTools(item)"
                   :style="getToolsStyle(item)"></i>
              </el-tooltip>
            </el-popover>
          </div>
        </div>
        <div class="rightTools">
          <div v-for="item in rightTools.slice(0,1)" :key="item.name" @click="handleRightTools(item,$event)"
               v-show="!item.isHide">
            <el-popover
              placement="top"
              width="auto"
              trigger="click"
              ref="mPopover"
              :openDelay="200"
            >
              <div v-if="item.name === 'os' && item.children && item.children.length"
                   style="display:grid;justify-items: center; cursor: pointer"
                   :style="{'grid-template-columns' : `repeat(${item.children.length},1fr)`}">
                <div style="width: 50px;text-align: center;" v-for="it in item.children" @click="openOS(it)"
                     v-show="!it.isHide">
                  <el-tooltip :content="it.systemType" placement="top" effect="light">
                    <i :class="it.css" style="font-size:24px;"
                       :style="{color:currentEnv.systemType === it.systemType ? '#21a7fd' : null}"></i>
                  </el-tooltip>
                </div>
              </div>
              <el-tooltip slot="reference" :content="item.label" placement="top" effect="light" v-show="!item.isHide">
                <i :class="item.type"></i>
              </el-tooltip>
            </el-popover>
          </div>
          <div v-for="item in rightTools.slice(1,2)" :key="item.name" @click="handleRightTools(item,$event)"
               v-show="!item.isHide">
            <el-popover
              placement="top"
              width="auto"
              trigger="click"
              ref="mPopover"
              :openDelay="200">
              <div style="max-height: 300px;overflow-y: auto;padding: 5px">
                <div v-for="note in noteList" class="officeReEditLoadBook" @click="selectNote(note)"
                     :style="{border:currentNodeId === note.id ? '1px solid #21a7fd' : null}">
                  <el-image :key="note.id" :src="note.notesUrl" fit="fill" lazy>
                    <div slot="error">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
                <p v-if="!noteList || !noteList.length" style="text-align: center">
                  暂无
                </p>
              </div>
              <el-tooltip slot="reference" :content="item.label" placement="top" effect="light" v-show="!item.isHide">
                <i :class="item.type"></i>
              </el-tooltip>
            </el-popover>
          </div>
          <div v-for="item in rightTools.slice(2)" :key="item.name" @click="handleRightTools(item,$event)"
               v-show="!item.isHide">
            <el-tooltip slot="reference" :content="item.label" placement="top" effect="light">
              <i :class="item.type"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import iconCaChu from '@/assets/icon/icon_cachu.png';
import iconPen from '@/assets/icon/icon_pen.png';
import {fabric} from 'fabric';
import 'fabric/src/mixins/eraser_brush.mixin'
import {
  base64ToFile,
  execWholeScreenshot,
  generatePictures,
  imageCompress,
  isLinuxLabOS
} from "@/utils/utils";
import popupFramework from "@/views/szrt_revision/teachingDetail/list/classroom/popupFramework.vue"
import qs from 'qs'
import {queryNotes, selectList, updateNotes} from "@/api/PostUrl";
import ItLoading from "@/views/szrt_revision/teachingDetail/list/classroom/itLoading";
import ItEnv from "@/views/szrt_revision/teachingDetail/list/classroom/itEnv";
import {teacherNotesUploadForMap} from "@/api/filePostApi";
import PreviewScreenshot from "@/views/szrt_revision/teachingDetail/list/classroom/previewScreenshot";

export default {
  name: "officeReEdit",
  components: {PreviewScreenshot, ItLoading, ItEnv, popupFramework},
  props: {
    drawBackgroundImage: {
      type: String,
      default: null
    },
    showToolsBox: {
      type: Boolean,
      default: true
    },
    initQuestionsRequestData: {
      type: Object,
      default: () => {
        return {
          userId: '',
          courseId: '',
          catalogId: '',
          classId: '',
        }
      }
    },
    toolBtStatus: {
      type: Array,
      default: () => [],
    },
    removeTools: {
      type: Array,
      default: () => [],
    }
  },
  watch: {
    'initQuestionsRequestData.catalogId': {
      handler(newVal) {
        this.pointPathId = ''
        newVal && this.queryNotes()
      },
      immediate: true
    },

    showToolsBox: {
      handler(newVal) {
        this.$BusEvent.$emit('_showLearningDetailsLeft_', Number(newVal))
      },
      immediate: true
    },
    toolBtStatus: {
      handler(newVal = []) {
        if (newVal.length > 0) {
          ['leftTools', 'centerTools', 'rightTools'].forEach(key => {
            const f = (list) => {
              list.forEach(item => {
                newVal.forEach(it => {
                  if (item.name === it.name) {
                    item.isHide = Boolean(it.isHide).valueOf()
                  }
                  Array.isArray(item.children) && f(item.children)
                })
              })
            }
            f(this[key])
          })
        }
      }
    },
    removeTools: {
      handler(newVal = []) {
        newVal.forEach(key => {
          this[key] = []
        })
      },
      immediate: true
    }
  },
  computed: {
    getToolsStyle() {
      return function (item) {
        let currentType = this.currentType.replace(this.startText, '')
        let ok = false
        if (item.children) {
          ok = item.children.some(it => it.name === currentType)
        }
        return {color: ok || item.name === currentType ? '#21a7fd' : null, cursor: 'pointer'}
      }
    },
    getDisableIsNext() {
      return function (index) {
        return (index === 0 && this.historyIndex <= -1) || (index === 1 && this.historyIndex >= this.historyList.length - 1) || !this.historyList.length
      }
    }
  },
  data() {
    return {
      currentEnv: {},
      envList: {
        codeBlockOS: {
          platformType: 'codeBlockOS',
          isLab: '0',
          css: 'iconfont icon-code',
          systemType: 'CodeBlock',
        },
        jupyterNoteBook: {
          platformType: 'jupyterNoteBook',
          isLab: '1',
          css: 'iconfont icon-jupyter',
        },
        liunxLabOS: {//这个后台本身就写错了，不能改key名称
          platformType: 'liunxLabOS',
          kernelType: 'vnc',
          isLab: '0',
          get css() {
            return (this.systemType || '').toLowerCase() === 'ubuntu' ? 'iconfont icon-ubuntu' : 'iconfont icon-centos'
          },
        },
        jupyterTerminals: {
          platformType: 'jupyterTerminals',
          kernelType: 'terminals',
          isLab: '0',
          css: 'iconfont icon-centos',
        }
      },
      currentNodeId: '',
      noteList: [],//笔记列表
      questionsList: [],
      popupFrameworkShow: false,
      startEl: null,
      endEl: null,
      loading: false,
      pTools: {
        show: true,
        prePageKey: 'prePage',
        nextPageKey: 'nextPage',
        domId: 'pptIframe'
      },
      iframeSrc: '',
      imagePath: null,
      isPointer: true,
      historyList: [],
      isEdit: true,
      isGeneratePictures: false,//生成图片时使用
      canvasWidth: 0,
      canvasHeight: 0,
      leftTools: [
        {
          name: 'openMenu',
          label: '收起(Shift+Q)',
          type: 'iconfont icon-xuanxiangcharu',
          isHide: false
        },
        {
          name: 'upQuestion',
          label: '上一节(Shift+W)',
          type: 'iconfont icon-prev',
          isHide: false
        },
        {
          name: 'prePage',
          label: '上一页',
          type: 'iconfont icon-backward',
          isHide: true
        },
        {
          name: 'nextPage',
          label: '下一页',
          type: 'iconfont icon-go',
          isHide: true
        },
        {
          name: 'nextQuestion',
          label: '下一节(Shift+E)',
          type: 'iconfont icon-next',
          isHide: false
        }
      ],
      centerTools: [
        {name: 'undo', label: '撤回(Ctrl+Z)', type: 'iconfont icon-weibiaoti545', isHide: false},
        {name: 'redo', label: '还原(Ctrl+Y)', type: 'iconfont icon-weibiaoti546', isHide: false},
        {
          name: 'mouse', label: '鼠标(Shift+空格)', type: 'iconfont icon-shoushi',
          currentType: '',
          isHide: false,
        },
        {name: 'pencil', label: '画笔(Shift+Z)', type: 'el-icon-edit', isHide: false},
        {
          name: 'eraser', label: '橡皮擦(Shift+D)', type: 'iconfont icon-xiangpica', isHide: false,
          children: [
            {name: 'clear', label: '清空(Shift+C)', type: 'el-icon-delete', isHide: false},
          ]
        },
        {
          name: 'more', label: '更多工具', type: 'iconfont icon-wenju', isHide: false,
          children: [
            {name: 'select', label: '选中(Shift+A)', type: 'iconfont icon-xuanze', isHide: false},
            {name: 'line', label: '直线', type: 'iconfont icon-zhixian', isHide: false},
            {name: 'arrow', label: '箭头', type: 'iconfont icon-jiantou_youxia', isHide: false},
            {name: 'dottedLine', label: '虚线', type: 'iconfont icon-xuxian', isHide: false},
            {name: 'text', label: '文本', type: 'iconfont icon-wenben', isHide: false},
            {name: 'rect', label: '矩形', type: 'iconfont icon-juxing', isHide: false},
            {name: 'circle', label: '圆', type: 'iconfont icon-xingzhuang-tuoyuanxing', isHide: false}
          ]
        }
      ],
      rightTools: [
        {
          name: 'os', label: '编程环境', type: 'iconfont icon-daimashengcheng', isHide: false,
          children: []
        },
        {name: 'loadBook', label: '加载板书', type: 'el-icon-attract', isHide: false,},
        {name: 'image', label: '保存板书', type: 'iconfont icon-tupian', isHide: false,},
      ],
      currentLine: null,
      currentPolygon: null,
      currentCircle: null,
      currentRect: null,
      officeCanvas: null,
      downPoint: null,
      movePoint: null,
      upPoint: null,
      currentType: 'mouse',
      currentItem: null,
      startText: 'encode_',
      mObjectsLength: 0,
      historyIndex: -1,
      currentColor: '#000000',
      currentWidth: 6,
      fill: 'transparent', // 填充色：透明
      currentShapeWidth: 6,
      predefineColors: ['#ffffff', '#cccccc', '#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#34495e', '#f1c40f', '#e67e22', '#e74c3c', '#d35400', '#ecf0f1', '#95a5a6', '#bdc3c7', '#7f8c8d'],

      currentShapeColor: '#000000',
      currentEraserWidth: 30,
      predefineShapeColors: ['#ffffff', '#cccccc', '#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#34495e', '#f1c40f', '#e67e22', '#e74c3c', '#d35400', '#ecf0f1', '#95a5a6', '#bdc3c7', '#7f8c8d'],
      messageListener: null,
      pointPathId: '',
      pointPathSort: '',
      currentPath: null,//当前笔迹路径
      // upTypeInfo:{},//上一次使用的工具信息
      generatePicturesEditor: false,
      userId: sessionStorage.getItem('userId')
    }
  },
  directives: {
    drag(el, binding, node) {
      const that = node.context
      const value = binding.value
      that.mouseup = true
      el.onmousedown = (dev) => {
        that.mouseup = false
        const parentEl = el.parentElement
        parentEl.style.transition = 'all 0s'
        that.setIframePointerEvents(false)
        if (value === 'left') {
          const right = document.body.offsetWidth - parentEl.offsetWidth - parentEl.offsetLeft
          parentEl.style.right = right + 'px'
          parentEl.style.left = ''
          window.onmousemove = (mev) => {
            requestAnimationFrame(() => {
              if (!that.mouseup) {
                let width = document.body.offsetWidth - mev.clientX + 10 - right
                if (width > document.body.offsetWidth / 2 && width <= document.body.offsetWidth) {
                  parentEl.style.width = width + 'px'
                }
              }
            })
          }
        } else if (value === 'right') {
          const left = parentEl.offsetLeft
          parentEl.style.left = left + 'px'
          parentEl.style.right = ''
          window.onmousemove = (mev) => {
            requestAnimationFrame(() => {
              if (!that.mouseup) {
                let width = mev.clientX - left
                if (width > document.body.offsetWidth / 2 && width <= document.body.offsetWidth) {
                  parentEl.style.width = width + 'px'
                }
              }
            })
          }
        }
        const mouseup = (uev) => {
          that.mouseup = true
          parentEl.style.transition = 'all .5s'
          that.setIframePointerEvents(true)
          window.removeEventListener('mouseup', mouseup)
        }
        window.addEventListener('mouseup', mouseup)
      }
    }
  },
  created() {
    this.initSelectPlatformType()
  },
  mounted() {
    this.canvasWidth = window.screen.width * 2;
    this.canvasHeight = window.screen.height * 2;
    this.$nextTick(() => this.initCanvas())
    //通知当前模式为上课模式
    this.$BusEvent.$emit('_isClassMode_', this.showToolsBox)
    this.$nextTick(() => {
      let bts = document.querySelectorAll('.el-color-dropdown__link-btn')
      bts.forEach(bt => bt.style.display = 'none')
    })
  },
  beforeDestroy() {
    this.historyList = []
  },
  methods: {
    resetOs() {
      console.log('resetOs')
      this.$refs.itEnv.reset()
    },
    restartOs() {
      console.log('restartOs')
      this.$refs.itEnv.restart()
    },
    setIframePointerEvents(up) {
      const iframes = document.querySelectorAll('iframe')
      if (up) {
        Array.from(iframes).forEach(iframe => iframe.style.pointerEvents = 'auto')
      } else {
        Array.from(iframes).forEach(iframe => iframe.style.pointerEvents = 'none')
      }
    },
    // 初始化画板
    initCanvas() {
      this.officeCanvas = new fabric.Canvas('officeCanvas')
      this.setCurrentType(this.currentType)
      //绑定画板事件
      this.addCanvasEvent(this.officeCanvas)
    },
    /**
     * @param item
     */
    setCurrentType(item) {
      if (item instanceof Object) {
        this.currentItem = item
        this.currentType = item.name
      }
      this.typeChange(this.currentType)
    },
    /**
     * 画布操作类型切换
     * @param opt
     */
    typeChange(opt) {
      this.IText && this.IText.exitEditing();
      this.isPointer = false
      this.imagePath = null
      this.currentType = opt ? opt.replace(this.startText, '') : this.currentType
      this.officeCanvas.devicePixelRatio = true //Retina 高清屏 屏幕支持
      this.officeCanvas.isDrawingMode = false
      this.officeCanvas.selectionColor = this.fill // 选框填充色：透明
      this.officeCanvas.selectionBorderColor = this.fill // 选框边框颜色：透明度很低的黑色（看上去是灰色）
      this.officeCanvas.defaultCursor = 'default'
      this.officeCanvas.freeDrawingCursor = 'default'
      this.setSelectable(false)
      switch (this.currentType) {
        case 'mouse':
          this.isPointer = true
          break
        case 'select':
          this.setSelectable(true)
          break
        case 'eraser': // 橡皮擦
          this.officeCanvas.isDrawingMode = true
          this.officeCanvas.freeDrawingBrush = new fabric.EraserBrush(this.officeCanvas) // 使用橡皮擦画笔
          this.officeCanvas.freeDrawingBrush.width = this.currentEraserWidth // 设置橡皮粗细
          this.imagePath = iconCaChu
          this.setFreeDrawingCursor()
          break
        case 'pencil': // 创建画笔
          // 将画布设置成绘画模式
          this.officeCanvas.freeDrawingBrush = new fabric.PencilBrush(this.officeCanvas)
          this.officeCanvas.isDrawingMode = true
          this.officeCanvas.freeDrawingBrush.width = this.currentWidth //画笔宽度
          this.officeCanvas.freeDrawingBrush.color = this.currentColor//画笔颜色
          // this.officeCanvas.freeDrawingBrush.strokeDashArray = [20, 50]//虚线
          this.officeCanvas.freeDrawingBrush.limitedToCanvasSize = true//不可超出可视范围
          this.imagePath = iconPen
          this.setFreeDrawingCursor()
          break
        case 'text': // 文字
          this.officeCanvas.defaultCursor = 'text'
          this.officeCanvas.freeDrawingCursor = 'text'
          break
      }
    },
    setSelectable(status = false) {
      this.officeCanvas.selectable = status // 是否允许框选
      this.officeCanvas.selection = status // 是否允许框选
      this.officeCanvas.skipTargetFind = !status // 禁止选中
      if (!status) {
        this.officeCanvas.discardActiveObject()
        this.officeCanvas.renderAll();
      }
    },
    /**
     * 事件监听
     */
    addCanvasEvent() {
      document.onmouseup = () => {
        this.doPopoverClose()
      }
      document.onkeydown = () => {

        let oEvent = window.event;
        console.log(oEvent.code)
        if (oEvent.code === 'Delete') { // 选中删除
          this.addHistory()
          let objs = this.officeCanvas.getActiveObjects()
          if (objs) {
            objs.forEach(obj => {
              this.officeCanvas.remove(obj)
            })
          }
          this.mObjectsLength = this.officeCanvas.getObjects().length
        } else if (oEvent.ctrlKey && oEvent.code === 'KeyY') { //前进
          this.redo()
        } else if (oEvent.ctrlKey && oEvent.code === 'KeyZ') { //撤回
          this.undo()
        } else if (oEvent.shiftKey && oEvent.code === 'Space') { //鼠标
          this.setSwitch(this.centerTools[2])
        } else if (oEvent.shiftKey && oEvent.code === 'KeyA') { //选中
          let parent = this.centerTools[5]
          this.setSwitch(parent, parent.children[0])
        } else if (oEvent.shiftKey && oEvent.code === 'KeyZ') { //画笔
          this.setSwitch(this.centerTools[3])
        } else if (oEvent.shiftKey && oEvent.code === 'KeyD') { //橡皮
          this.setSwitch(this.centerTools[4])
        } else if (oEvent.code === 'F2') { //展示隐藏工具条
          this.switchTools()
        } else if (oEvent.shiftKey && oEvent.code === 'KeyA') { //选中
          let parent = this.centerTools[5]
          this.setSwitch(parent, parent.children[0])
        } else if (oEvent.shiftKey && oEvent.code === 'KeyQ') { //展开
          this.openMenu()
        } else if (oEvent.shiftKey && oEvent.code === 'KeyW') { //上一节
          this.prev()
        } else if (oEvent.shiftKey && oEvent.code === 'KeyE') { //下一节
          this.next()
        } else if (oEvent.shiftKey && oEvent.code === 'KeyC') { //下一节
          this.clearCanvas()
        }
      }
      this.officeCanvas.on('mouse:down', this.canvasMouseDown)   // 鼠标在画布上按下
      this.officeCanvas.on('mouse:up', this.canvasMouseUp)       // 鼠标在画布上松开
      this.officeCanvas.on('mouse:move', this.canvasMouseMove);    // 鼠标在画布上移动
      this.officeCanvas.on('selection:created', this.selectionCreated);    // 当对象选中时
      this.officeCanvas.on('selection:cleared', this.selectionCleared);    // 当对象失去选中时
    },
    /**
     *快捷键切换
     * @param childrenItem
     */
    setSwitch(parent, children) {
      this.doPopoverClose()
      // //切换为选中
      if (children) {
        // Object.assign(parent, children)
        // parent.currentType = this.currentType
        this.handleCenterTools(children)
      } else {
        this.handleCenterTools(parent)
      }
    },
    doPopoverClose() {
      if (this.$refs.mPopover && this.$refs.mPopover.length) {
        this.$refs.mPopover.forEach(item => item.doClose())
      }
    },
    /**
     * 上一步
     */
    undo(index) {
      if (this.IText) this.IText.exitEditing();
      this.IText = null
      if (!this.getDisableIsNext(index)) {
        --this.historyIndex
        if (this.historyIndex >= 0) {
          const obj = this.historyList[this.historyIndex]
          obj && this.officeCanvas.loadFromJSON(obj)
        } else {
          this.historyIndex = -1
          this.officeCanvas.clear()
        }
      }
    },
    /**
     * 下一步
     */
    redo(index) {
      if (!this.getDisableIsNext(index)) {
        ++this.historyIndex
        if (this.historyIndex <= this.historyList.length) {
          const obj = this.historyList[this.historyIndex]
          obj && this.officeCanvas.loadFromJSON(obj)
        } else {
          this.historyIndex = this.historyList.length
        }
      }
    },

    /**
     * 鼠标在画布上按下
     * @param e
     */
    canvasMouseDown(e) {
      // 鼠标左键按下时，将当前坐标 赋值给 downPoint。{x: xxx, y: xxx} 的格式
      this.downPoint = e.absolutePointer
      if (this.currentType === 'text') {
        this.createText()
      }
    },
    /**
     * 鼠标在画布上松开
     * @param e
     */
    canvasMouseUp(e) {
      this.upPoint = e.absolutePointer
      //如果元素被添加 添加历史记录
      this.addHistory()
      this.resetData()
    },
    selectionCreated(e) {
      setTimeout(() => {
        this.currentType = `${this.startText}${this.currentType}`
        if (Array.isArray(e.deselected) && e.deselected[0].type === 'textbox') {
          this.IText = e.deselected[0]
          this.addITextEvent(this.IText)
        }
      })
    },
    selectionCleared(e) {
      this.currentType = this.currentType.replace(this.startText, '')
    },
    /**
     * 添加历史记录
     */
    addHistory() {
      const length = this.officeCanvas.getObjects().length
      if (this.mObjectsLength !== length) {
        if (this.currentType !== 'text') {
          this.historyListPush()
        }
      } else {
        this.historyList[this.historyIndex] = this.getJSON()
      }
      console.log('添加历史记录:', this.historyIndex, this.historyList.length, this.currentType, this.mObjectsLength)
    },
    historyListPush() {
      let json = this.getJSON()
      this.historyList.push(json)
      this.historyIndex = this.historyList.length - 1
      this.mObjectsLength = this.officeCanvas.getObjects().length
    },
    getJSON() {
      return JSON.stringify(this.officeCanvas.toJSON())
    },

    /**
     * 重置数据
     */
    resetData() {
      this.downPoint = null
      this.upPoint = null
      this.movePoint = null
      this.currentLine = null
      this.currentPolygon = null
      this.currentCircle = null
      this.currentRect = null
      // this.officeCanvas.skipTargetFind = false // 允许选中
    },

    /**
     * 鼠标在画布上移动
     * @param e
     */
    canvasMouseMove(e) {
      this.drawView(e)
    },
    /**
     * @param e
     */
    drawView(e) {
      if (this.downPoint) {
        this.movePoint = e.absolutePointer
        let key = this.currentType.slice(0, 1).toUpperCase() + this.currentType.slice(1);
        let func = this[`draw${key}`];
        if (typeof func === 'function') func();
      }
    },
    /**
     * 创建圆形开始
     */
    drawCircle() {
      if (this.currentCircle) {
        this.officeCanvas.remove(this.currentCircle)
      }
      let radius = Math.min(Math.abs(this.downPoint.x - this.movePoint.x), Math.abs(this.downPoint.y - this.movePoint.y)) / 2
      // 计算圆形的top和left坐标位置
      let top = this.movePoint.y > this.downPoint.y ? this.downPoint.y : this.downPoint.y - radius * 2
      let left = this.movePoint.x > this.downPoint.x ? this.downPoint.x : this.downPoint.x - radius * 2
      // 使用 Fabric.js 提供的api创建圆形，此时圆形的半径是0
      this.currentCircle = new fabric.Circle({
        top: top,
        left: left,
        radius: radius,
        fill: this.fill,
        stroke: this.currentShapeColor, // 笔触颜色
        strokeWidth: this.currentShapeWidth
      })
      this.officeCanvas.add(this.currentCircle)
    },
    /**
     * 创建矩形
     */
    drawRect() {
      if (this.currentRect) {
        this.officeCanvas.remove(this.currentRect)
      }
      // 创建矩形
      // 矩形参数计算
      let top = Math.min(this.downPoint.y, this.movePoint.y)
      let left = Math.min(this.downPoint.x, this.movePoint.x)
      let width = Math.abs(this.downPoint.x - this.movePoint.x)
      let height = Math.abs(this.downPoint.y - this.movePoint.y)

      // 矩形对象
      this.currentRect = new fabric.Rect({
        top,
        left,
        width,
        height,
        fill: this.fill, // 填充色：透明
        stroke: this.currentShapeColor, // 笔触颜色
        strokeWidth: this.currentShapeWidth
      })
      this.officeCanvas.add(this.currentRect)
    },
    /**
     * 虚线
     */
    drawDottedLine() {
      this.drawLine([20, 10])
    },
    /**
     * 直线/虚线
     */
    drawLine(strokeDashArray) {
      if (this.currentLine) {
        this.officeCanvas.remove(this.currentLine)
      }
      let options = JSON.parse(JSON.stringify({
        strokeDashArray: strokeDashArray,
        stroke: this.currentShapeColor, // 笔触颜色
        strokeWidth: this.currentShapeWidth
      }))
      this.currentLine = new fabric.Line(
        [
          this.downPoint.x, this.downPoint.y, // 起始点坐标
          this.movePoint.x, this.movePoint.y // 结束点坐标
        ],
        options
      )
      this.officeCanvas.add(this.currentLine)
    },
    /**
     * 箭头
     */
    drawArrow() {
      if (this.currentPolygon) {
        this.officeCanvas.remove(this.currentPolygon)
      }

      let headlen = Math.max(this.currentShapeWidth / 1.5, 17.5)
      let theta = headlen
      // 计算各角度和对应的P2,P3坐标
      let angle = Math.atan2(this.downPoint.y - this.movePoint.y, this.downPoint.x - this.movePoint.x) * 180 / Math.PI,
        angle1 = (angle + theta) * Math.PI / 180,
        angle2 = (angle - theta) * Math.PI / 180,
        //上面的一个点
        topX = headlen * Math.cos(angle1),
        topY = headlen * Math.sin(angle1),

        //下面的一个点
        botX = headlen * Math.cos(angle2),
        botY = headlen * Math.sin(angle2);

      let path = " M " + this.downPoint.x + " " + this.downPoint.y;//起点1
      path += " L " + this.movePoint.x + " " + this.movePoint.y;//结束点1
      path += 'z'

      let arrowX = this.movePoint.x + topX;
      let arrowY = this.movePoint.y + topY;

      path += " M " + arrowX + " " + arrowY;//起点2
      path += " L " + this.movePoint.x + " " + this.movePoint.y;
      let arrowX2 = this.movePoint.x + botX;
      let arrowY2 = this.movePoint.y + botY;
      path += " L " + arrowX2 + " " + arrowY2;
      path += 'z'
      this.currentPolygon = new fabric.Path(path, {
        fill: this.currentShapeColor,
        stroke: this.currentShapeColor, // 笔触颜色
        strokeWidth: this.currentShapeWidth / 2
      });
      this.officeCanvas.add(this.currentPolygon)
    },
    /**
     * 创建文字
     */
    createText() {
      if (this.IText && !this.IText.text) {
        this.IText.exitEditing();
        this.officeCanvas.remove(this.IText)
      }
      this.IText = new fabric.Textbox('', this.getTextOption())
      this.officeCanvas.add(this.IText)
      this.IText.enterEditing();
      this.addITextEvent(this.IText)
    },
    addITextEvent(e) {
      if (!e) return
      let properties = this.getTextOption();
      e.on('changed', () => {
        let left = document.body.offsetWidth - e.width
        let top = document.body.offsetHeight - e.height
        if (left <= e.left + properties.fontSize) {
          e.left = left - properties.fontSize
        }
        if (top <= e.top + properties.fontSize) {
          e.top = top - properties.fontSize * 2
        }
      });
      e.on('editing:exited', () => {
        console.log('editing:exited')
        if (e.text) {
          this.historyListPush()
        }
      });
      e['setControlVisible']('ml', false)
      e['setControlVisible']('mb', false)
      e['setControlVisible']('mr', false)
      e['setControlVisible']('mt', false)
    },
    getTextOption() {
      return {
        left: this.downPoint.x,
        top: this.downPoint.y,
        fontSize: this.currentShapeWidth < 30 ? 30 : this.currentShapeWidth,  // 字体大小
        fill: this.currentShapeColor,  // 字体颜色
        width: 0,
        selectable: true, //选中当前元素
        hasBorders: true, //显示选中时的边
        hasControls: true,//显示控制的那9个按钮
        objectCaching: false
      }
    },
    /**
     * 中间的工具条
     * @param it
     * @param item
     */
    handleCenterTools(item, index) {
      console.log('--->', item)
      this.doPopoverClose()
      if (item.name === 'undo') {
        return this.undo(index)
      } else if (item.name === 'redo') {
        return this.redo(index)
      } else if (item.name === 'clear') {
        return this.clearCanvas(true)
      } else if (item.name === 'more') {
        return
      }
      this.setCurrentType(item)
    },
    clearCanvas(reset) {
      const length = this.officeCanvas.getObjects().length
      if (length) {
        this.addHistory()
        ++this.historyIndex
        reset && this.resetBtn()
      }
      return this.officeCanvas.clear()
    },
    resetBtn() {
      this.setCurrentType(this.centerTools[2])
    },
    /**
     * 左边的工具条
     * @param item
     */
    handleLeftTools(item) {
      let mIframe = document.getElementById(this.pTools.domId)
      this.$emit('menuClick', item)
      if (item.name === 'upQuestion') {//上一节
        this.prev()
      } else if (item.name === 'nextQuestion') {//下一节
        this.next()
      } else if (item.name === 'openMenu') {
        this.openMenu(item)
      } else {
        let wind = window
        if (mIframe instanceof HTMLIFrameElement) {
          wind = mIframe.contentWindow
        }
        if (item.name === 'nextPage') {
          wind.postMessage(this.pTools.nextPageKey, '*')
        } else if (item.name === 'prePage') {
          wind.postMessage(this.pTools.prePageKey, '*')
        }
      }
    },
    openMenu(item) {
      this.$BusEvent.$emit('_showLearningDetailsLeft_', true)
      this.$emit('openSide')
      if (item.label.startsWith('展开')){
        item.label=item.label.replace('展开','收起')
      }else {
        item.label=item.label.replace('收起','展开')
      }
    },
    /**
     * 右边工具条
     */
    async handleRightTools(item, ev) {
      if (item.name === 'loadBook') {
        const noteList = this.noteList
        this.noteList = []
        this.$nextTick(() => this.noteList = noteList)
      } else if (item.name === 'os') {
        //记录按下坐标
        this.startEl = this.endEl = ev.target
      } else if (item.name === 'image') {
        await this.generatePictures()
      } else {
        this.rightTools[7].name = item.name
        this.setCurrentType(item)
      }
    },
    /**
     * 切换 显示、隐藏工具条
     */
    switchTools() {
      this.isEdit = !this.isEdit
      this.$emit('switchTools', this.isEdit)
    },
    pickerChange(color, key) {
      this[key] = color;
      this.setCurrentType()
    },
    pickersChange(colors, color, defColor) {
      colors.unshift(color)
      if (colors.length > 20) {
        colors = [...colors.slice(0, 20)]
      }
    },
    sliderChange() {
      this.setCurrentType()
    },

    /**
     * 设置光标
     */
    setFreeDrawingCursor() {
      let currentWidth = (this.currentType === 'eraser' ? this.currentEraserWidth : this.currentWidth) + 20
      this.imagePath && imageCompress(this.imagePath, currentWidth, currentWidth, (base64) => {
        this.officeCanvas.freeDrawingCursor = this.currentType === 'eraser' ? `url(${base64}) ${currentWidth / 1.949} ${currentWidth / 1.949}, auto` : `url(${base64}), auto`;
      })
    },
    /**
     * 生成图片
     * @param editor 是否为编辑模式 板书列表编辑时用到
     * @param callBack 成功时调用
     * @returns {Promise<void>}
     */
    async generatePictures(editor, callBack) {
      this.isGeneratePictures = true
      this.generatePicturesEditor = editor
      this.generatePicturesSallBack = callBack
      this.$nextTick(async () => {
        let formData = new FormData();
        if (editor) {
          const base64 = await generatePictures(this.$refs.officeReEdit).finally(() => this.isGeneratePictures = false)
          formData.append('file', base64ToFile(base64));
          await this.savePictures(formData, editor, callBack)
        } else {
          let currentItem = this.currentItem
          this.resetBtn()
          this.editor = editor
          const userId = localStorage.getItem('alreadyReadScreenshotTip')
          if (userId !== this.userId) {//标识用户已经查看过错误提示
            return this.$showPreviewScreenshot('请按照如图操作进行截图', this.closeTip)
          }
          await execWholeScreenshot(this.$refs.officeCanvas, true).then(images => {
            formData.append('file', base64ToFile(images[0]));
            formData.append('file2', base64ToFile(images[1]));
            this.savePictures(formData, editor, callBack)
          }).catch(error => this.showTip(error))
            .finally(() => {
              this.isGeneratePictures = false
              this.currentItem && this.setCurrentType(currentItem)
            })

        }
      })
    },
    showTip(error) {
      if ((error instanceof Object) && error.type === 'screenshot' && error.code === -1) {
        return this.$showPreviewScreenshot('截图方式错误，请按照如图操作', this.closeTip)
      }
    },
    closeTip() {
      localStorage.setItem('alreadyReadScreenshotTip', this.userId)
      this.generatePictures(this.generatePicturesEditor, this.generatePicturesSallBack)
    },
    async savePictures(formData, editor, callBack) {
      let header = {
        ...this.initQuestionsRequestData,
        teacherNotesId: this.pointPathId == null ? '' : this.pointPathId,
        sort: this.pointPathSort,
      }
      console.log('header===>',header)
      let {teacherNotesId} = await teacherNotesUploadForMap(formData, header)
      updateNotes.params.id = teacherNotesId
      updateNotes.params.notesTrace = this.getJSON()
      this.$apiPost.httpPostForMap(updateNotes).then(() => {
        (typeof callBack === 'function') && callBack()
        this.$messageSuccess(!editor ? '保存板书已成功，请在板书页签进行查看' : '板书保存成功')
        this.queryNotes()
      })
    },

    handlerVideo() {
      let video = document.getElementById('newCourseVideo')
      video.setAttribute('crossOrigin', 'anonymous');
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');

      let canvas = document.createElement('canvas')
      canvas.width = video.offsetWidth;
      canvas.height = video.offsetHeight;
      let ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, video.offsetWidth, video.offsetHeight);
      let base64 = canvas.toDataURL('image/png');
      img.src = base64;
      video.parentElement.replaceChildren(img)
    },
    handleIframe(mIframe, width, height) {
      let imgBase64 = null
      let iframeHtml = mIframe.contentWindow // 获取iframe内容
      const iframeBody = iframeHtml.document.getElementsByTagName('body')[0]
      const iframeScrollY = iframeHtml.document.documentElement.scrollTop
      const iframeScrollX = iframeHtml.document.documentElement.scrollLeft
      return new Promise((resolve, reject) => {
        html2canvas(iframeBody, {
          allowTaint: true,
          useCORS: true,
          width: width, // TODO 截屏按照1920*1080分辨率下的预览窗口宽高
          height: height,
          x: iframeScrollX,
          y: iframeScrollY
        }).then(canvas => {
          // 转成图片，生成图片地址
          imgBase64 = canvas.toDataURL('image/png')
          if (imgBase64) {
            resolve(imgBase64)
          } else {
            reject(new Error('发生错误'))
          }
        })
      })
    },

    prev() {
      this.$emit('prev')
    },
    next() {
      this.$emit('next')
    },
    /**
     * 初始化要选择的平台类型
     */
    async initSelectPlatformType() {
      if (this.rightTools && this.rightTools[0] && this.rightTools[0].children) {
        const {itCourseList} = await this.$apiPost.httpPostForMap(selectList, {courseId: null})
        if (Array.isArray(itCourseList)) {
          this.rightTools[0].children = itCourseList.map(item => ({
            ...Object.assign(this.envList[item.platformType], item),
            css: this.envList[item.platformType].css
          }))
          this.rightTools[0].children.unshift(this.envList['codeBlockOS'])
        }
      }
    },
    /**
     * 打开编辑器
     * @param item
     */
    openOS(item) {
      this.doPopoverClose()
      this.currentEnv = item
      this.popupFrameworkShow = true
      if (!Object.prototype.hasOwnProperty.call(this.envList, item.platformType)) {
        console.log('platformType', item.platformType)
        return this.$messageError('平台类型错误')
      }
      if (item.platformType === this.envList.codeBlockOS.platformType) return;
      const authorization = localStorage.getItem("Authorization")
      const userId = sessionStorage.getItem("userId")
      if (authorization && userId) {
        let productFlag = `${sessionStorage.getItem('productFlag')}`;
        let sourceId = '';
        if (productFlag === '1' || productFlag === '2') {   //单项
          sourceId = `TEACH_${this.initQuestionsRequestData.courseId}_${this.initQuestionsRequestData.classId}_1_NONE`
        } else if (productFlag === '3') {   //综合
          sourceId = `TEACH_${this.initQuestionsRequestData.courseId}_${this.initQuestionsRequestData.classId}_2_NONE`
        }

        let params = {
          edu_token: authorization,
          userId: userId,
          sourceId: sourceId,
          questionId: item.questionId,
          catalogId: this.initQuestionsRequestData.catalogId,
          templeteCode: '',
          roleCodes: '',
          isLab: '0'
        };
        if (item.platformType === this.envList.jupyterNoteBook.platformType) {
          params['isLab'] = this.envList.jupyterNoteBook.isLab;
        } else if (item.platformType === this.envList.jupyterTerminals) {
          params['kernelType'] = this.envList.jupyterTerminals.kernelType;
        }
        let iframeSrc = ''
        if (isLinuxLabOS(item.platformType)) {
          params['kernelType'] = this.envList.liunxLabOS.kernelType
          iframeSrc = process.env.VUE_APP_LINUXHUB + '/hub/login?' + qs.stringify(params)
        } else { // isLab
          iframeSrc = process.env.VUE_APP_COS + '?' + qs.stringify(params)
        }
        this.iframeSrc = iframeSrc
      } else {
        this.$messageError('账户信息未获取成功');
      }
    },
    popupResize(state, status) {
      if (state === status.close) {//窗口关闭
        this.iframeSrc = ''
        this.currentEnv = {}
      }
    },
    /**
     * 笔迹回显
     * @param data
     */
    pathRepaint(data = {}) {
      this.pointPathId = data.pointPathId
      this.pointPathSort = data.sort
      if (typeof data.pointPath === 'string') {
        try {
          const pathObject = JSON.parse(data.pointPath)
          if (Array.isArray(pathObject.objects)) {
            this.officeCanvas.loadFromJSON(data.pointPath)//还原
            this.historyList.push(data.pointPath)
            this.historyIndex = this.historyList.length - 1
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    async queryNotes() {
      queryNotes.params.catalogId = this.initQuestionsRequestData.catalogId
      queryNotes.params.classId = this.initQuestionsRequestData.classId
      queryNotes.params.courseId = this.initQuestionsRequestData.courseId
      const noteList = await this.$apiPost.httpPostForMap(queryNotes)
      this.noteList = (noteList || []).reverse()
    },
    selectNote(note) {
      if (note) {
        this.currentNodeId = note.id
        this.pathRepaint({pointPathId: note.id, pointPath: note.notesTrace})
      }
    },
    maximizeTools(target) {
      console.log(target.className)
      if (target.className === 'officeTools') {
        target.style.left = '0'
        target.style.width = '100vw'
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import url('../../../../../../src/assets/fonts/text/iconfont.css');
@import url('../../../../../../src/assets/fonts/next/iconfont.css');
@import url('../../../../../../src/assets/fonts/option/iconfont.css');
@import url('../../../../../../src/assets/fonts/chehui/iconfont.css');
@import url('../../../../../../src/assets/fonts/xuanzhong/iconfont.css');
@import url('../../../../../../src/assets/fonts/os/iconfont.css');

::-webkit-scrollbar {
  display: none;
}

.officeReEditLoadBook {
  height: 90px;
  width: 130px;
  margin-bottom: 8px;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 4px rgba(62, 62, 62, 0.24);
}

.officeReEdit {
  height: 100%;
  width: 100%;
  position: fixed;
  overflow: hidden;
  z-index: 2001;

  .officeContent {
    position: relative;
    width: inherit;
    overflow: hidden;
    height: 100%;

    .canvasBox {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: 2002;
      margin: 0;
      padding: 0;
    }

    .contentBox {
      width: inherit;
      height: 100%;
      position: relative;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
    }
  }

  .officeTools {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    right: 0;
    height: 80px;
    z-index: 2003;
    padding-left: 10px;
    padding-right: 10px;
    box-shadow: 0 -2px 4px rgba(107, 107, 107, 0.15);
    background: linear-gradient(180deg, rgba(251, 251, 252, 0.7) 0%, rgba(245, 245, 247, 1) 100%);
    backdrop-filter: blur(5px);
    box-sizing: border-box;
    transition: .5s;
    transform: translateY(var(--translateY));

    & > .drag {
      position: absolute;
      user-select: none;
      cursor: e-resize;
      z-index: 9;
      font-size: 12px;
      color: #c2c2c2;
      width: 20px;
      height: 80px;
      display: flex;
      align-items: center;
    }

    & > .dragLeft {
      left: 10px;
    }

    & > .dragRight {
      right: 0;
    }

    i {
      font-size: 30px;
      transition: .3s;
    }

    i:hover {
      font-size: 60px;
    }

    .rightTools {
      width: 300px;
      height: inherit;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      & > div {
        cursor: pointer;
        margin-left: 16px;
        margin-right: 20px;
      }
    }
  }

  .centerTools {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 300px;
    height: 100%;
  }

  .leftTools {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 300px;
    height: 100%;

    & > div {
      margin-left: 20px;
      cursor: pointer;
    }

    & > div:nth-of-type(1) {
      margin-right: auto;

      i {
        font-size: 26px;
      }
    }

    i {
      font-size: 30px;
    }
  }

  .fold {
    cursor: pointer;
    position: absolute;
    z-index: 2001;
    left: 50%;
    bottom: 80px;
    transform: translateX(-50%);
    background-color: rgba(250, 250, 249, 0.69);
    backdrop-filter: blur(5px);
    height: 20px;
    width: 100px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 -2px 4px rgba(107, 107, 107, 0.15);

    i {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/teachingDetail/list/classroom/officeReEdit.vue